import { Profile, RoleTypeMap} from "../interfaces";

export class ProfileAdapter {
    value: Profile;

    constructor(input: any) {
        this.value = input.data
    }

    get avatar() {
        if (!this.value.avatar) {
            return `${process.env.PUBLIC_URL}/images/user-empty-state.svg`;
        }

        return `${process.env.REACT_APP_API_ASSETS}${(this.value?.avatar?.id || this.value.avatar)}}`;
    }

    get role() {
        return RoleTypeMap[this.value.role?.name as keyof typeof RoleTypeMap]
    }

    adapt() {
        return {
            id : this.value?.id,
            email: this.value.email,
            fullname: `${this.value.first_name} ${this.value.last_name}`,
            first_name: this.value.first_name,
            last_name: this.value.last_name,
            avatar: this.avatar,
            phone: this.value.phone,
            role: this.role,
            location : this.value.location || ''
        }
    }
}